<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1 style="font-family:Calisto MT; font-size:18pt; letter-spacing:1px; padding-top:75px; padding-bottom:15px;">Acknowledgment</h1>
<p style="text-indent:0em;">I would like to thank my mother, Marjorie Januzelli, for always supporting me in whatever endeavors I chose to pursue. My mom was always there for me no matter what and encouraged me to be the best at whatever I decided to do. I would also like to thank my stepdad, Donald Kelley, who brought me into the world of racing and taught me that I could do whatever I set my mind to. In addition, I cannot thank my boss, Jim Fuller, enough. He was my biggest supporter who launched my career and stood by me no matter what. He enabled me to achieve a lifelong dream thereby changing history forever. Finally, I would like to thank Chris Goodlett and Jessica Whitehead from the Kentucky Derby Museum. Chris talked to me way back in the year 2000 about helping me finish my autobiography which I had started in 1995. However, I just wasn’t in the right frame of mind to finish it at that time. 20 years later I called him and asked him if he was still willing to help. He said yes. This would not have come to fruition if he had said no. Chris proofed and edited all of my chapters and advised me along the way. Also, Jessica Whitehead has proven to be invaluable with her advice on publishers and her advice on the book. I am so grateful for Chris and Jessica’s support and help throughout this project. There are probably others that I have not mentioned. So, I say to all who have encouraged me and supported me throughout my endeavors, “Thank you.”</p><br/>
<p style="text-indent:0em;">Cover Photos by Ira Gay Sealy, Denver Post, 1969</p><br/>
<p style="text-indent:0em;">A note to my readers:</p>
<p style="text-indent:0em;">If you are interested in further information on the topic of the book, I have included a list of articles that I referenced within my text at the end of the book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?1d6c07d0